module.exports = __webpack_public_path__ + "static/media/24.5ded97e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/24.png
// module id = 527
// module chunks = 0